import { NeuButtonUtility } from '@hcahealthcaredpx/neutron-react';

import styles from '../../../booking.module.css';

interface NavigationProps {
  onPrev: () => void;
  onNext: () => void;
}

export const Navigation = ({ onPrev, onNext }: NavigationProps): JSX.Element => {
  return (
    <div id="buttons" className={styles.timepickerNavigation}>
      <NeuButtonUtility
        // Todo: add i18n translation phrases
        label="Previous"
        color="plain"
        icon="keyboard_arrow_left"
        size="default"
        onNeuClick={(ev) => {
          ev.nativeEvent.preventDefault();
          onPrev();
        }}
      />
      <NeuButtonUtility
        label="Next"
        color="plain"
        icon="keyboard_arrow_right"
        size="default"
        onNeuClick={(ev) => {
          ev.nativeEvent.preventDefault();
          onNext();
        }}
      />
    </div>
  );
};
